import { render, staticRenderFns } from "./FileUploadPreviewItem.vue?vue&type=template&id=2830e0f0&scoped=true&"
import script from "./FileUploadPreviewItem.vue?vue&type=script&lang=js&"
export * from "./FileUploadPreviewItem.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadPreviewItem.vue?vue&type=style&index=0&id=2830e0f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830e0f0",
  null
  
)

export default component.exports